import { Component, OnInit } from '@angular/core';
import { CardCandidatoComponent } from './../card-candidato/card-candidato.component';
import { ListaCandidatos } from '../lista-candidatos'
@Component({
  selector: 'app-cart-list-candidato',
  templateUrl: './cart-list-candidato.component.html',
  styleUrls: ['./cart-list-candidato.component.css']
})
export class CartListCandidatoComponent implements OnInit {
  public Cards :Array<CardCandidatoComponent>= [];

  constructor() {
    //this.Cards = this.getList();

   }

  ngOnInit() {
    this.Cards = new ListaCandidatos().getList();
  }
  
  clicou(id:any) {
    console.log(id);
  }
}
